import { List, ListItemButton } from "@mui/material";
import { useLocation } from "react-router-dom";

import SidebarItem from "components/Navigation/SidebarItem";
import MenuIcon from "assets/icons/menu.svg?react";
import Logo from "assets/USPA-logo.svg?react";

import styles from "./Sidebar.module.css";

const Sidebar = ({ navItems }) => {
    const { pathname } = useLocation();

    return (
        <List className={styles.Sidebar} component="nav" data-testid="sidebar">
            <div className={styles.Sidebar_Logo} role="img" aria-label="Logo">
                <Logo />
            </div>
            {navItems.map((item) => (
                <>
                    <SidebarItem
                        key={item.link}
                        label={item.label}
                        link={item.link}
                        icon={item.icon}
                        isExternal={item.isExternal}
                        isActive={
                            pathname === ""
                                ? item.link === "/"
                                : pathname.includes(item.link)
                        }
                        hasSubItems={item.hasSubItems}
                        subItems={item.subItems}
                        subItemsLabel={item.subItemsLabel}
                    />
                </>
            ))}
            <div className={styles.Sidebar_Main_Overlap}>
                <div className={styles.Header_Curve} />
            </div>
        </List>
    );
};

export default Sidebar;
